import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {GuestView} from '../../components/guest/views/view';
import {IParticipantStore} from './participant.stores';

interface ParticipantViewProps {
    participantStore: IParticipantStore;
}

@observer
export class ParticipantViewComponent extends TechseeBaseComponent<ParticipantViewProps> {
    renderInternal(): JSX.Element {
        const {participantStore} = this.props;

        return <GuestView controller={participantStore.guestController} />;
    }
}

export const ParticipantView = inject('participantStore')(ParticipantViewComponent) as IReactComponent;
